import { useQuery } from '@tanstack/react-query';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useContentAncestorsQuery = (contentId: string) => {
  const queryKey = [QueryKey.DRIVE, 'ancestors', contentId || ''];
  const {
    data: ancestors,
    isLoading,
    isError,
  } = useQuery(queryKey, () => DriveRequests.getContentAncestors(contentId), {
    enabled: !!contentId,
    keepPreviousData: true,
  });

  return {
    ancestors,
    isAncestorsLoading: isLoading,
    ancestorsError: isError,
  };
};
